import { useCallback } from 'react';

import Card from '#globalComponents/Card/Card';
import Switch from '#globalComponents/Forms/Switch';
import { useAuth } from '#globalContexts/AuthProvider';
import { useSaveUserSettings } from '#settingsFeature/models/userSettings/mutations';
import { useUserSettings } from '#settingsFeature/models/userSettings/queries';

const AiSettingsTab = () => {
	const { user } = useAuth();
	const userId = user?.id;
	const { data: settings } = useUserSettings();
	const save = useSaveUserSettings();

	const aiNextActionEnabled = settings?.userSettings?.aiNextActionEnabled !== false;

	const handleToggle = useCallback(() => {
		const updated = {
			...(settings?.userSettings ?? {}),
			aiNextActionEnabled: !aiNextActionEnabled,
		};
		save.mutate({ id: userId, updates: { userSettings: updated } });
	}, [userId, settings, aiNextActionEnabled, save]);

	return (
		<div className="space-y-6">
			<div>
				<h2 className="text-lg font-semibold text-text mb-1">KI-Funktionen</h2>
				<p className="text-sm text-bgBase-800">Steuere, welche KI-gestützten Funktionen im CRM aktiv sind.</p>
			</div>

			<Card className="p-0 divide-y divide-bgBase-500">
				<div className="flex items-center justify-between px-5 py-4">
					<div>
						<div className="text-sm font-medium text-text">Nächste beste Aktion</div>
						<div className="text-xs text-bgBase-800 mt-0.5">
							KI-generierte Handlungsempfehlungen auf der Firmendetailseite pro Deal
						</div>
					</div>
					<Switch checked={aiNextActionEnabled} onChange={handleToggle} disabled={save.isPending} />
				</div>
			</Card>
		</div>
	);
};

export default AiSettingsTab;
